module.exports = __webpack_public_path__ + "static/img/3_1.cbc37b65.jpg";